import type { AxiosInstance } from 'axios';
import { Event, EventList } from './types';
import { PaginateOptions } from '../types';

export class EventsService {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  async list(options: PaginateOptions): Promise<EventList> {
    const response = await this.instance.get<EventList>('/events', {
      params: options,
    });
    console.log(response.data);
    return response.data;
  }

  async getById({ id }: { id: number }): Promise<Event> {
    const response = await this.instance.get<Event>(`/events/${id}`, {
      params: {
        dbOnly: false,
      },
    });
    return response.data;
  }

  async downloadCsv( eventId: number ): Promise<void> {
    try {
      const response = await this.instance.get<any>(`/orders/download-csv/${eventId}`, {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Event-${eventId}.csv`);
      document.body.appendChild(link);
      link.click();

      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading the CSV file:', error);
      throw error
    }
  }
}